/**
 * American Vek: <av-variant-refresh data-block-id="..."> swaps its content with the matching
 * element of the section HTML that Horizon fetches when a variant is selected
 * (shopify:product:select). Lets av-* product blocks (SKU, Pix, installments) follow the variant
 * without editing native JS.
 */
class AvVariantRefresh extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener('shopify:product:select', this.onSelect);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('shopify:product:select', this.onSelect);
  }

  onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      ?.then(({ detail }) => {
        const html = detail?.html;
        if (!html) return;
        const fresh = html.querySelector(`av-variant-refresh[data-block-id="${this.dataset.blockId}"]`);
        if (fresh) this.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  };
}

if (!customElements.get('av-variant-refresh')) customElements.define('av-variant-refresh', AvVariantRefresh);
